import React, { Component } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, IconButton } from "@mui/material";
import { FormControl } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
// import MoreOptions from "../priceListOption";
import settings from "../../helpers/settings";
import Row from "react-bootstrap/Row";
import Cookies from "js-cookie";
import Col from "react-bootstrap/Col";
import axios from "axios";
import * as XLSX from "xlsx";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Accordion from "react-bootstrap/Accordion";
import InputLabel from "@mui/material/InputLabel";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

let { KayanURL } = settings;
const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  borderRadius: "20px",
  p: 4,
};
const allInsuraceCompanies = {
  "LICNS-00007": "OQIC Test (LICNS-00007)",
  "NI/23": "LIVA prod (NI/23)",
  "NI/32": "OQIC Prod (NI/32)",
  "FI/9": "New India Prod (FI/9)",
  "LICNS-00001": "AXA Test (LICNS-00001)",
  "LICNS-00014": "Mednet Test (LICNS-00014)",
  "FI/6": "AXA Prod (FI/6)",
  "TPA/004": "Mednet Prod (TPA/004)",
  "LICNS-202315": "New India Test (LICNS-202315)",
  "LICNS-2023156": "Damana Test (LICNS-2023156)",
  "TPA/003": "Vipul Prod (TPA/003)",
  "FI/35": "Damana Prod (FI/35)",
  "LICNS-202329": "Vipul Test (LICNS-202329)",
  "FI/15": "Metlife Prod (FI/15)",
  "TPA/001": "Greenline Prod (TPA/001)",
  "FI/15": "Metlife (FI/15)",
  "LICNS-00013": "Nextcare (LICNS-00013)",
};
const InsuraceCompanies = {
  15: "LICNS-00007",
  17: "NI/23",
  20: "NI/32",
  21: "FI/9",
  22: "LICNS-00001",
  23: "LICNS-00014",
  24: "FI/6",
  25: "TPA/004",
  26: "LICNS-202329",
  27: "TPA/003",
  28: "LICNS-2023156",
  29: "FI/35",
  30: "LICNS-202315",
  31: "FI/15",
  32: "LICNS-00013",
};
class priceListManagment extends Component {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
    this.state = {
      selectedFile: "",
      extentionFile: false,
      searchInfoFound: false,
      searchInfo: {},
    };
  }
  componentDidMount = async () => {
    this.getPriceList();
  };
  onFileChange = (e) => {
    const allowedExtensions = ["xlsx"];
    const fileExtension = e.target.files[0].name.split(".").pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      this.setState({
        extentionFile: true,
      });
    } else
      this.setState({
        selectedFile: e.target.files[0],
        fileMsg: "",
        extentionFile: false,
      });
  };
  handleFileUpload = (e) => {
    if (!this.state.selectedFile && !this.state.extentionFile) {
      this.setState({
        fileMsg: "Make sure to select a file to upload",
      });
    } else if (!this.state.selectedFile && this.state.extentionFile) {
      this.setState({
        fileMsg:
          "It seems you've tried to upload a file with an unsupported extension. Currently, we only accept the following file types: .xlsx",
      });
    } else {
      this.setState({ fileMsg: "", extentionFile: false, uploadLoading: true });
      const reader = new FileReader();
      reader.readAsBinaryString(this.state.selectedFile);
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const parsedData = XLSX.utils.sheet_to_json(sheet);
        let arr = [];
        for (let i = 0; i < parsedData.length; i++) {
          arr.push({
            payerlicense: parsedData[i]["Payer License"],
            standardcode: parsedData[i]["Standard Code"]
              ? parsedData[i]["Standard Code"]
              : "",
              nonstandardcode: parsedData[i]["Non Standard Code"]
              ? parsedData[i]["Non Standard Code"]
              : "",
            price: parsedData[i]["Price"] ? parsedData[i]["Price"] : 0,
            tax: parsedData[i]["Tax"] ? parsedData[i]["Tax"] : 0,
            factor: parsedData[i]["Factor"] ? parsedData[i]["Factor"] : 0,
            patientshare: parsedData[i]["Patient Share"]
              ? parsedData[i]["Patient Share"]
              : 0,
          });
        }
        this.sendReq(arr, e);
        // }
      };
    }
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = null;
    }
    this.setState({ selectedFile: "" });
  };
  sendReq = async (parsedData, e) => {
    console.log(parsedData, "ppppppppppppppp");
    let Response = await axios.post(
      KayanURL + "/test/patients/priceList/addPriceList",
      {
        data: parsedData,
        apiToken: Cookies.get("id"),
      }
    );
    if (Response) {
      let { data } = Response;
      if (data) {
        setTimeout(() => {
          this.setState({ uploadLoading: false });
        }, 1000);
        console.log("data:", data);
        if (data.success) {
          this.setState({ success: true, uploadModal: false });
          this.getPriceList();
        } else {
          this.setState({ success: false, error: data.error });
        }
      }
    }
  };

  closeUploadModal = () => {
    this.setState({
      uploadModal: false,
      selectedFile: "",
      fileMsg: "",
    });
  };

  getPriceList = async () => {
    this.setState({ getPriceListSent: "true" });
    let priceList = await axios.put(
      KayanURL + "/test/patients/priceList/getAllPriceList",
      {
        apiToken: Cookies.get("id"),
      }
    );
    if (priceList) {
      let { data } = priceList;
      if (data) {
        this.setState({ getPriceListSent: false, searchInfoFound: false });
        if (data.success) {
          let { priceList } = data;
          // console.log(priceList, "data")
          this.setState({ priceList: priceList });
        } else {
          this.setState({ error: data.error });
        }
      }
    }
  };
  getPriceListByInfo = async (searchInfo) => {
    let priceList = await axios.put(
      KayanURL + "/test/patients/priceList/getAllPriceListByInfo",
      {
        apiToken: Cookies.get("id"),
        searchInfo: searchInfo,
      }
    );
    if (priceList) {
      let { data } = priceList;
      if (data) {
        this.setState({ searchLoading: false });
        if (data.success) {
          let { priceList } = data;
          this.setState({ priceList: priceList, searchInfoFound: true });
        } else {
          this.setState({ error: data.error });
        }
      }
    }
  };
  handleClosePriceListModal = () => {
    this.setState({ updatePriceListModal: false });
  };
  deletePriceList = async (id) => {
    let response = await axios.put(
      KayanURL + "/test/patients/priceList/deletePriceList",
      {
        ID: id,
        apiToken: Cookies.get("id"),
      }
    );

    if (response) {
      let { data } = response;
      if (data.success) {
        this.getPriceList();
      } else {
        let { error } = data;
        if (error) {
          this.setState({ error: error });
        }
      }
    }
  };
  handleUpdatePriceList = async (element) => {
    this.setState({
      updatePriceListModal: true,
    });
    // console.log(element, "selected");
    // console.log(element["payerlicense"][0], "payerrrrr");
    if (element) {
      this.setState({
        id: element["id"],
        standardcode: element["standardcode"],
        nonstandardcode: element["nonstandardcode"],
        price: element["price"],
        factor: element["factor"],
        tax: element["tax"],
        patientshare: element["patientshare"],
        payerId: element["payerlicense"][0],
      });
    }
  };
  handleTextChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  updatePriceList = async () => {
    let response = await axios.put(
      KayanURL + "/test/patients/priceList/updatePriceList",
      {
        data: {
          ID: this.state.id,
          standardcode: this.state.standardcode,
          nonstandardcode: this.state.nonstandardcode,
          price: this.state.price,
          tax: this.state.tax,
          factor: this.state.factor,
          patientshare: this.state.patientshare,
          payerId: [this.state.payerId],
        },
        apiToken: Cookies.get("id"),
      }
    );

    if (response) {
      let { data } = response;
      if (data.success) {
        this.getPriceList();
        this.setState({ updatePriceListModal: false });
      } else {
        let { error } = data;
        if (error) {
          this.setState({ error: error });
        }
      }
    }
  };
  HandleInputSearchRequestTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name === "standardCode") {
      this.setState({
        searchInfo: { ...this.state.searchInfo, standardcode: value },
        [name]: value,
      });
    } else if (name === "nonStandardCode") {
      this.setState({
        searchInfo: { ...this.state.searchInfo, nonstandardcode: value },
        [name]: value,
      });
    } else {
      console.log(InsuraceCompanies[value],'searchhhhhhhh')
      this.setState({
        searchInfo: { ...this.state.searchInfo, [name]: InsuraceCompanies[value] },
        [name]: value,
      });
    }
  };
  handleSearchRequest = async () => {
    let { searchInfo } = this.state;
    if (Object.keys(searchInfo).length === 0 || searchInfo === undefined) {
      this.setState({
        searchErrMsg: "Please select a value to search",
        searchMsg: "",
      });
    }
    for (let key in searchInfo) {
      if (searchInfo.hasOwnProperty(key) && searchInfo[key] === "") {
        this.setState({
          searchErrMsg: "Please select a value to search",
          searchMsg: "",
        });
      } else {
        this.setState({
          searchErrMsg: "",
          searchLoading: true,
        });
        this.getPriceListByInfo(searchInfo);
      }
    }
    this.setState({
      searchInfo: {},
      payerid: "",
      standardCode: "",
      nonStandardCode: "",
    });
  };
  render() {
    let { priceList } = this.state;
    console.log(this.state.searchInfo, "search");
    let priceListRows = [];
    if (priceList && priceList.length > 0) {
      priceListRows = priceList.map((element, index) => {
        let payers = [];
        if (
          element.payerlicense &&
          element.payerlicense.length > 0 &&
          element.payerlicense[0] !== "All"
        ) {
          payers.push(
            allInsuraceCompanies[element.payerlicense[0]]
          );
        }
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.payerlicense &&
              element.payerlicense.length > 0 &&
              element.payerlicense[0] === "All"
                ? element.payerlicense.toString()
                : payers.toString()}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.standardcode}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.nonstandardcode}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.price}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.tax}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.factor}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.patientshare}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              <div>
                <a
                  style={{ cursor: "pointer", marginRight: "5px" }}
                  onClick={() => this.handleUpdatePriceList(element)}
                >
                  <EditIcon style={{ fontSize: "17px" }} />
                </a>
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => this.deletePriceList(element.id)}
                >
                  <DeleteIcon style={{ fontSize: "17px" }} />
                </a>
              </div>
            </TableCell>
          </TableRow>
        );
      });
    }
    return (
      <div>
        <div
          style={{
            textAlign: "center",
            margin: "auto",
            boxShadow: "1px solid grey",
            padding: "15px",
            boxShadow:
              "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
            borderRadius: "10px",
            marginTop: "50px",
            width: "95%",
          }}
        >
          <div style={{ textAlign: "left" }}>
            <Button
              variant="contained"
              style={{
                backgroundColor: "rgb(97 110 120",
                border: "1px ridge gray",
                width: "25%",
                boxShadow: "none",
                height: "35px",
                color: "white",
                fontSize: "small",
                marginTop: "20px",
                marginRight: "10px",
                transition: "background-color 0.4s, color 0.4s",
              }}
              onClick={() => this.setState({ uploadModal: true })}
            >
              {this.state.uploadLoading ? "Loading..." : "Upload File"}
            </Button>
          </div>
          <Accordion
            defaultActiveKey="0"
            style={{
              margin: "30px auto",
              paddingBottom: "20px",
              width: "65%",
            }}
          >
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <span style={{ color: "grey" }}>Search Price List</span>
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col style={{ width: "33.33%" }}>
                    <FormControl sx={{ mb: 3 }} style={{ width: "100%" }}>
                      <InputLabel id="insurance" style={{ fontSize: "small" }}>
                        Insurance Company
                      </InputLabel>
                      <Select
                        required
                        labelId="insurance"
                        name="payerid"
                        label="Insurance Company"
                        value={this.state.payerid ? this.state.payerid : ""}
                        onChange={this.HandleInputSearchRequestTextChange}
                        style={{ height: "45px" }}
                      >
                        <MenuItem value="All" style={{ fontSize: "small" }}>
                          All
                        </MenuItem>
                        <MenuItem value="30" style={{ fontSize: "small" }}>
                          New India Test (LICNS-202315)
                        </MenuItem>
                        <MenuItem value="15" style={{ fontSize: "small" }}>
                          OQIC Test (LICNS-00007)
                        </MenuItem>
                        <MenuItem value="22" style={{ fontSize: "small" }}>
                          AXA Test (LICNS-00001)
                        </MenuItem>
                        <MenuItem value="23" style={{ fontSize: "small" }}>
                          Mednet Test (LICNS-00014)
                        </MenuItem>
                        <MenuItem value="26" style={{ fontSize: "small" }}>
                          Vipul Test (LICNS-202329)
                        </MenuItem>
                        <MenuItem value="28" style={{ fontSize: "small" }}>
                          Damana Test (LICNS-2023156)
                        </MenuItem>
                        <MenuItem value="17" style={{ fontSize: "small" }}>
                          LIVA prod (NI/23)
                        </MenuItem>
                        <MenuItem value="21" style={{ fontSize: "small" }}>
                          New India Prod (FI/9)
                        </MenuItem>
                        <MenuItem value="20" style={{ fontSize: "small" }}>
                          OQIC Prod (NI/32)
                        </MenuItem>
                        <MenuItem value="24" style={{ fontSize: "small" }}>
                          AXA Prod (FI/6)
                        </MenuItem>
                        <MenuItem value="25" style={{ fontSize: "small" }}>
                          Mednet Prod (TPA/004)
                        </MenuItem>
                        <MenuItem value="27" style={{ fontSize: "small" }}>
                          Vipul Prod (TPA/003)
                        </MenuItem>
                        <MenuItem value="29" style={{ fontSize: "small" }}>
                          Damana Prod (FI/35)
                        </MenuItem>
                        <MenuItem value="31" style={{ fontSize: "small" }}>
                          Metlife (FI/15)
                        </MenuItem>
                        <MenuItem value="32" style={{ fontSize: "small" }}>
                          Nextcare (LICNS-00013)
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Col>
                  <Col style={{ width: "33.33%" }}>
                    <FormControl fullWidth sx={{ mb: 3 }}>
                      <TextField
                        InputLabelProps={{ sx: { fontSize: "small" } }}
                        inputProps={{ sx: { padding: "11px" } }}
                        required
                        name="standardCode"
                        label="Standard Code"
                        variant="outlined"
                        onChange={this.HandleInputSearchRequestTextChange}
                        value={
                          this.state.standardCode ? this.state.standardCode : ""
                        }
                      />
                    </FormControl>
                  </Col>
                  <Col style={{ width: "33.33%" }}>
                    <FormControl fullWidth sx={{ mb: 3 }}>
                      <TextField
                        InputLabelProps={{ sx: { fontSize: "small" } }}
                        inputProps={{ sx: { padding: "11px" } }}
                        required
                        name="nonStandardCode"
                        label="Non Standard Code"
                        variant="outlined"
                        onChange={this.HandleInputSearchRequestTextChange}
                        value={
                          this.state.nonStandardCode
                            ? this.state.nonStandardCode
                            : ""
                        }
                      />
                    </FormControl>
                  </Col>
                </Row>
                <div style={{ width: "100%" }}>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "rgb(97 110 120",
                      marginRight: "10px",
                      transition: "background-color 0.4s, color 0.4s",
                    }}
                    onClick={(e) => this.handleSearchRequest(e)}
                  >
                    {this.state.searchLoading ? "Loading..." : "Search"}
                  </Button>
                  {this.state.searchErrMsg ? (
                    <>
                      <Typography style={{ textAlign: "center", color: "red" }}>
                        {this.state.searchErrMsg}
                      </Typography>
                    </>
                  ) : null}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          {this.state.getPriceListSent ? (
            <div style={{ textAlign: "center" }}>
              <CircularProgress />
            </div>
          ) : priceList && priceList.length > 0 ? (
            <div style={{ width: "96%", margin: "auto" }}>
              {this.state.searchInfoFound ? (
                <>
                  <div style={{ textAlign: "left" }}>
                    <a
                      style={{
                        fontSize: "12px",
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                      onClick={this.getPriceList}
                    >
                      Back To All
                    </a>
                  </div>
                </>
              ) : null}
              <TableContainer
                component={Paper}
                style={{ marginTop: "20px", overflowX: "auto" }}
              >
                <Table sx={{ minWidth: 100 }} aria-label="simple table">
                  <TableHead style={{ backgroundColor: "#fafafa" }}>
                    <TableRow style={{ textAlign: "center" }}>
                      <TableCell align="center">Payer ID</TableCell>
                      <TableCell align="center">Standard Code</TableCell>
                      <TableCell align="center">Non Standard Code</TableCell>
                      <TableCell align="center">Price</TableCell>
                      <TableCell align="center">Tax</TableCell>
                      <TableCell align="center">Factor</TableCell>
                      <TableCell align="center">Patient Share</TableCell>
                      <TableCell align="center">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{priceListRows}</TableBody>
                </Table>
              </TableContainer>
            </div>
          ) : this.state.searchInfoFound &&
            priceList &&
            priceList.length === 0 ? (
            <>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                style={{
                  textAlign: "center",
                  color: "red",
                  marginTop: "10px",
                  fontSize: "15px",
                }}
              >
                No Record Found!
              </Typography>
              <div style={{ textAlign: "left" }}>
                <a
                  onClick={this.getPriceList}
                  style={{
                    fontSize: "12px",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                >
                  Back To All
                </a>
              </div>
            </>
          ) : (
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{
                textAlign: "center",
                color: "red",
                marginTop: "10px",
                fontSize: "15px",
              }}
            >
              The price list make sure to upload it.
            </Typography>
          )}
          {this.state.uploadModal ? (
            <>
              <Modal
                open={this.state.uploadModal}
                onClose={this.closeUploadModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ overflowY: "scroll" }}
              >
                <Box
                  sx={styleModal}
                  style={{
                    width: "30%",
                    height: "200px",
                    border: "1px solid white",
                    textAlign: "center",
                  }}
                >
                  <input
                    style={{
                      display: "block",
                      margin: "auto",
                      marginRight: "5px",
                    }}
                    type="file"
                    ref={this.fileInputRef}
                    onChange={this.onFileChange}
                  />
                  {this.state.fileMsg ? (
                    <>
                      <div style={{ textAlign: "center" }}>
                        <span
                          style={{
                            color: "red",
                            fontSize: "10px",
                          }}
                        >
                          {this.state.fileMsg}
                        </span>
                      </div>
                    </>
                  ) : null}

                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "rgb(97 110 120",
                      border: "1px ridge gray",
                      width: "40%",
                      boxShadow: "none",
                      height: "35px",
                      color: "white",
                      fontSize: "small",
                      marginTop: "20px",
                    }}
                    onClick={this.handleFileUpload}
                  >
                    Upload File
                  </Button>
                </Box>
              </Modal>
            </>
          ) : null}
          {this.state.updatePriceListModal ? (
            <>
              <Modal
                open={this.state.updatePriceListModal}
                onClose={this.handleClosePriceListModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ overflowY: "scroll" }}
              >
                <Box
                  sx={styleModal}
                  style={{
                    width: "50%",
                    height: "450px",
                    overflowY: "scroll",
                    border: "1px solid white",
                    padding: "40px",
                  }}
                >
                  <Row>
                    <Col xs={6} style={{ width: "50%" }}>
                      <FormControl sx={{ mb: 3 }} style={{ width: "100%" }}>
                        <InputLabel
                          id="insurance"
                          style={{ fontSize: "small" }}
                        >
                          Insurance Company
                        </InputLabel>
                        <Select
                          required
                          labelId="insurance"
                          name="payerId"
                          label="Insurance Company"
                          value={this.state.payerId ? this.state.payerId : ""}
                          onChange={this.handleTextChange}
                          style={{ height: "45px" }}
                        >
                          <MenuItem value="All" style={{ fontSize: "small" }}>
                            All
                          </MenuItem>
                          <MenuItem value="30" style={{ fontSize: "small" }}>
                            New India Test (LICNS-202315)
                          </MenuItem>
                          <MenuItem value="15" style={{ fontSize: "small" }}>
                            OQIC Test (LICNS-00007)
                          </MenuItem>
                          <MenuItem value="22" style={{ fontSize: "small" }}>
                            AXA Test (LICNS-00001)
                          </MenuItem>
                          <MenuItem value="23" style={{ fontSize: "small" }}>
                            Mednet Test (LICNS-00014)
                          </MenuItem>
                          <MenuItem value="26" style={{ fontSize: "small" }}>
                            Vipul Test (LICNS-202329)
                          </MenuItem>
                          <MenuItem value="28" style={{ fontSize: "small" }}>
                            Damana Test (LICNS-2023156)
                          </MenuItem>
                          <MenuItem value="17" style={{ fontSize: "small" }}>
                            LIVA prod (NI/23)
                          </MenuItem>
                          <MenuItem value="21" style={{ fontSize: "small" }}>
                            New India Prod (FI/9)
                          </MenuItem>
                          <MenuItem value="20" style={{ fontSize: "small" }}>
                            OQIC Prod (NI/32)
                          </MenuItem>
                          <MenuItem value="24" style={{ fontSize: "small" }}>
                            AXA Prod (FI/6)
                          </MenuItem>
                          <MenuItem value="25" style={{ fontSize: "small" }}>
                            Mednet Prod (TPA/004)
                          </MenuItem>
                          <MenuItem value="27" style={{ fontSize: "small" }}>
                            Vipul Prod (TPA/003)
                          </MenuItem>
                          <MenuItem value="29" style={{ fontSize: "small" }}>
                            Damana Prod (FI/35)
                          </MenuItem>
                          <MenuItem value="31" style={{ fontSize: "small" }}>
                            Metlife (FI/15)
                          </MenuItem>
                          <MenuItem value="32" style={{ fontSize: "small" }}>
                            Nextcare (LICNS-00013)
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth sx={{ mb: 3 }}>
                        <TextField
                          InputLabelProps={{ sx: { fontSize: "small" } }}
                          inputProps={{ sx: { padding: "11px" } }}
                          required
                          name="standardcode"
                          label="Standard Code"
                          variant="outlined"
                          onChange={this.handleTextChange}
                          value={
                            this.state.standardcode
                              ? this.state.standardcode
                              : ""
                          }
                        />
                      </FormControl>

                      <FormControl fullWidth sx={{ mb: 3 }}>
                        <TextField
                          InputLabelProps={{ sx: { fontSize: "small" } }}
                          inputProps={{ sx: { padding: "11px" } }}
                          type="number"
                          required
                          name="price"
                          label="Price"
                          variant="outlined"
                          onChange={this.handleTextChange}
                          value={
                            this.state.price
                              ? this.state.price
                              : this.state.price === 0
                              ? this.state.price
                              : null
                          }
                        />
                      </FormControl>

                      <FormControl fullWidth sx={{ mb: 3 }}>
                        <TextField
                          InputLabelProps={{ sx: { fontSize: "small" } }}
                          inputProps={{ sx: { padding: "11px" } }}
                          type="number"
                          required
                          name="tax"
                          label="Tax"
                          variant="outlined"
                          onChange={this.handleTextChange}
                          value={
                            this.state.tax
                              ? this.state.tax
                              : this.state.tax === 0
                              ? this.state.tax
                              : null
                          }
                        />
                      </FormControl>
                    </Col>

                    <Col xs={6} style={{ width: "50%" }}>
                      <FormControl fullWidth sx={{ mb: 3 }}>
                        <TextField
                          InputLabelProps={{ sx: { fontSize: "small" } }}
                          inputProps={{ sx: { padding: "11px" } }}
                          required
                          name="nonstandardcode"
                          label="Non Standard Code"
                          variant="outlined"
                          onChange={this.handleTextChange}
                          value={
                            this.state.nonstandardcode
                              ? this.state.nonstandardcode
                              : ""
                          }
                        />
                      </FormControl>
                      <FormControl fullWidth sx={{ mb: 3 }}>
                        <TextField
                          InputLabelProps={{ sx: { fontSize: "small" } }}
                          inputProps={{ sx: { padding: "11px" } }}
                          type="number"
                          required
                          name="factor"
                          label="Factor"
                          variant="outlined"
                          onChange={this.handleTextChange}
                          value={
                            this.state.factor
                              ? this.state.factor
                              : this.state.factor === 0
                              ? this.state.factor
                              : null
                          }
                        />
                      </FormControl>

                      <FormControl fullWidth sx={{ mb: 3 }}>
                        <TextField
                          InputLabelProps={{ sx: { fontSize: "small" } }}
                          inputProps={{ sx: { padding: "11px" } }}
                          type="number"
                          required
                          name="patientshare"
                          label="Patient Share"
                          variant="outlined"
                          onChange={this.handleTextChange}
                          value={
                            this.state.patientshare
                              ? this.state.patientshare
                              : this.state.patientshare === 0
                              ? this.state.patientshare
                              : null
                          }
                        />
                      </FormControl>
                    </Col>
                  </Row>
                  <div style={{ textAlign: "center" }}>
                    <Button
                      variant="primary"
                      type="submit"
                      onClick={(e) => this.updatePriceList(e)}
                      style={{
                        width: "30%",
                        marginTop: "10px",
                        backgroundColor: "rgb(97 110 120",
                        border: "1px solid rgb(97 110 120",
                        color: "white",
                      }}
                    >
                      Update
                    </Button>
                  </div>
                </Box>
              </Modal>
            </>
          ) : null}
        </div>
      </div>
    );
  }
}

export default priceListManagment;
